import React from 'react';
import { Container, Divider, Stack, Typography } from '@drone-js/core';
import { useSelector } from 'react-redux';
import { selectScreenSize } from 'store/slice/screen';

export interface OfferTagItemProps {
    tagName: string;
    tagValue: string;
    isLastIndex?: boolean;
}

const TagContent: React.FC<Pick<OfferTagItemProps, 'tagName' | 'tagValue'>> = ({ tagName, tagValue }) => (
    <Stack direction="column" gap="4">
        <Typography variant="caption-default" textColor="base.subtle">
            {tagName}
        </Typography>
        <Typography variant="body-s-strong" lineClamp={2}>
            {tagValue}
        </Typography>
    </Stack>
);
TagContent.displayName = 'TagContent';

export const SummaryPanel: React.FC<OfferTagItemProps> = (props) => {
    const screenSize = useSelector(selectScreenSize);

    if (screenSize.desktop) {
        return (
            <Stack direction="row">
                <Container me="24">
                    <TagContent tagName={props.tagName} tagValue={props.tagValue} />
                </Container>
                {!props.isLastIndex && (
                    <>
                        <Divider direction="vertical" dividerStyle="dashed" />
                        <Container ms="24" />
                    </>
                )}
            </Stack>
        );
    }

    return (
        <Stack flexGrow={1} flexShrink={1} flexBasis="0" direction="column" gap="4">
            <TagContent tagName={props.tagName} tagValue={props.tagValue} />
        </Stack>
    );
};

SummaryPanel.displayName = 'SummaryPanel';
